<script>
import ChangeEditor from '@/components/TasksList/Change/ChangeEditor.vue'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import { $axios } from '@/modules/http/axios'

export default {
  name: 'ChangeListing',
  components: { ChangeEditor },
  props: ['task', 'colspan'],
  methods: {
    async deleteChange(task, cid) {
      const dialogResult = await Swal.fire({
        title: `Czy na pewno chcesz usunąć Przepinkę ze zlecenia ${task.numer_Przejazdu}?`,
        showConfirmButton: true,
        showCancelButton : true,
        confirmButtonText: 'Tak',
        cancelButtonText : 'Nie',
        icon: 'warning'
      })

      if (dialogResult.isConfirmed) {
        try {
          const response = (await $axios.delete(`${task.id}/Changes/${cid}`)).data
          emitter.emit('taskChanged', { taskId: task.id })
          if (response.relatedTaskId) { emitter.emit('taskChanged', { taskId: response.relatedTaskId }) }
          await Swal.fire(`Usunięto przepinkę ze zlecenia ${task.numer_Przejazdu}`, 'Dane Przepinki zostały usunięte', 'success')
        } catch (e) {
          if (e.response?.status !== 500) {
            await Swal.fire('Przepinka nie mogła zostać usunięta', `System nie był w stanie usunąć danych Przepinki ze zlecenia ${task.numer_Przejazdu} <br> <span class="fw-bold">Kod błędu: ${e.response.status}</span>`, 'error')
          } else {
            emitter.emit('taskChanged', { taskId: task.id })
          }
        }
      }
    }
  }
}
</script>

<template>
  <tr v-for="change in task.changes" :key="change.id">
    <td :colspan="colspan" class="text-start ps-4" :style="`background-color: ${task.altBackgroundColor};`">
      <strong>PRZEPINKA {{ change.acronym }} |&nbsp;</strong>
      <span :style="`color:${task.altTextColor};`">{{ change.date.replace('T', ' ') }}</span>
      <span>&nbsp;|&nbsp;</span>
      <strong :style="`color:${task.altTextColor};`">{{ change.vehicle.plateNumber }}</strong>
      <span>&nbsp;|&nbsp;</span>
      <span :style="`color:${task.altTextColor};`" v-for="(driver, i) in change.drivers" :key="driver.id">
        {{ driver.firstName }} {{ driver.surname }}<span v-show="i < change.drivers.length - 1">, </span>
      </span>
      <span>&nbsp;&nbsp;</span>
      <ChangeEditor :change="change" :task="task"/>
      <button class="btn btn-sm btn-danger ms-2" @click="deleteChange(task, change.id)">
        <i class="fa-solid fa-trash"></i>
      </button>
    </td>
  </tr>
</template>
